module.exports = __webpack_public_path__ + "img/browseHelp.376336be.svg";